[
  
    {
        "display": true,
        "ui_Field_Name": "Source",
        "field_Name": "source",
        "value": "",
        "datatype": "String",
        "db_columnname": "source",
        "isDisable": true,
        "isLargeField":false,
        "placeholder": "Please Enter Value",
        "maximumLength": false,
        "isrequired": false,
        "regexpressions": "",
        "dropdown": "NO",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": true,
        "ui_Field_Name": "Entity",
        "field_Name": "fileType",
        "value": "",
        "datatype": "String",
        "db_columnname": "fileType",
        "isDisable": true,
        "isLargeField":false,
        "placeholder": "Please Enter Value",
        "maximumLength": false,
        "isrequired": false,
        "regexpressions": "",
        "dropdown": "NO",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": true,
        "ui_Field_Name": "FDID RecordID",
        "field_Name": "fdidRecordID",
        "value": "",
        "datatype": "String",
        "db_columnname": "fdidRecordID",
        "isDisable": true,
        "isLargeField":false,
        "placeholder": "Please Enter Value",
        "maximumLength": false,
        "isrequired": false,
        "regexpressions": "",
        "dropdown": "NO",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    
    {
        "display": true,
        "ui_Field_Name": "CustomerRecordID",
        "field_Name": "customerRecordID",
        "value": "",
        "datatype": "String",
        "db_columnname": "customerRecordID",
        "isDisable": true,
        "isLargeField":false,
        "placeholder": "Please Enter Value",
        "maximumLength": false,
        "isrequired": false,
        "regexpressions": "",
        "dropdown": "NO",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": true,
        "ui_Field_Name": "InCustomerRecordID",
        "field_Name": "inCustomerRecordID",
        "value": "",
        "datatype": "String",
        "db_columnname": "inCustomerRecordID",
        "isDisable": true,
        "isLargeField":false,
        "placeholder": "Please Enter Value",
        "maximumLength": false,
        "isrequired": false,
        "regexpressions": "",
        "dropdown": "NO",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": true,
        "ui_Field_Name": "Rejection Timestamp",
        "field_Name": "rejectionTimestamp",
        "value": "",
        "datatype": "String",
        "db_columnname": "rejectionTimestamp",
        "isDisable": true,
        "isLargeField":false,
        "placeholder": "Please Enter Value",
        "maximumLength": false,
        "isrequired": false,
        "regexpressions": "",
        "dropdown": "NO",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": true,
        "ui_Field_Name": "File Name",
        "field_Name": "fileName",
        "value": "",
        "datatype": "String",
        "db_columnname": "fileName",
        "isDisable": true,
        "isLargeField":true,
        "placeholder": "Please Enter Value",
        "maximumLength": false,
        "isrequired": false,
        "regexpressions": "",
        "dropdown": "NO",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": false,
        "ui_Field_Name": "Tid",
        "field_Name": "tidValue",
        "value": "",
        "datatype": "String",
        "db_columnname": "tidValue",
        "isDisable": true,
        "isLargeField":true,
        "placeholder": "Please Enter Value",
        "maximumLength": false,
        "isrequired": false,
        "regexpressions": "",
        "dropdown": "NO",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": false,
        "ui_Field_Name": "Received FDID",
        "field_Name": "receivedFDID",
        "value": "",
        "datatype": "String",
        "db_columnname": "receivedFDID",
        "isDisable": true,
        "isLargeField":true,
        "placeholder": "Please Enter Value",
        "maximumLength": false,
        "isrequired": false,
        "regexpressions": "",
        "dropdown": "NO",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    }
]